import { getQueryString } from "utils/getQueryString";
import axios from "../axios";

const list = (queryParams = {}) => {
  return axios.get(`/companies-transactions?${getQueryString(queryParams)}`);
};

const review = (queryParams = {}) => {
  return axios.get(
    `/companies-transactions/review?${getQueryString(queryParams)}`
  );
};

const signature = (queryParams = {}) => {
  return axios.get(
    `/companies-transactions/signature?${getQueryString(queryParams)}`
  );
};

const corrections = (queryParams = {}) => {
  return axios.get(
    `/companies-transactions/corrections?${getQueryString(queryParams)}`
  );
};

const companiesTransactionsService = {
  list,
  review,
  signature,
  corrections,
};

export default companiesTransactionsService;
